/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { EmployeeAssistanceVisibility } from './EmployeeAssistanceVisibility';
import type { EmployeeExecutionAdvisory } from './EmployeeExecutionAdvisory';
/**
 * Advisory assistance that still merits attention.
 */
export type OpenEmployeeAdvisoryAssistance = {
    /**
     * Stable identifier for this individual assistance incident.
     */
    assistanceId: string;
    /**
     * AI Agent associated with the latest assistance outcome.
     */
    employeeId: string;
    /**
     * AI Agent version used by the latest execution.
     */
    version: (number | 'DRAFT');
    /**
     * CRM conversation associated with the assistance, when available.
     */
    conversationId?: number;
    /**
     * CRM funnel containing the conversation, when available.
     */
    funnelId?: number;
    /**
     * Latest execution that changed this assistance record.
     */
    latestExecutionId: string;
    /**
     * Objective active when the assistance outcome occurred.
     */
    objective: string;
    /**
     * Audience allowed to see this assistance record.
     */
    visibility: EmployeeAssistanceVisibility;
    /**
     * Time when this assistance context first became open.
     */
    openedAt: string;
    /**
     * Time when the record last changed.
     */
    updatedAt: string;
    /**
     * Advisory impact discriminator.
     */
    impact: OpenEmployeeAdvisoryAssistance.impact;
    /**
     * Sanitized issue that merits review without blocking the execution.
     */
    advisory: EmployeeExecutionAdvisory;
    /**
     * Open lifecycle state.
     */
    status: OpenEmployeeAdvisoryAssistance.status;
};
export namespace OpenEmployeeAdvisoryAssistance {
    /**
     * Advisory impact discriminator.
     */
    export enum impact {
        ADVISORY = 'advisory',
    }
    /**
     * Open lifecycle state.
     */
    export enum status {
        OPEN = 'open',
    }
}

